import { formatTimezoneOffset } from 'helpers/formatDateTime';

export const timezoneNameWithOffset = ({ gmtOffset, name }) => `(${formatTimezoneOffset(gmtOffset)}) ${name}`;
